import { render, staticRenderFns } from "./PrintableOrderSummary.vue?vue&type=template&id=22bffb75"
import script from "./PrintableOrderSummary.vue?vue&type=script&lang=js"
export * from "./PrintableOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./PrintableOrderSummary.vue?vue&type=style&index=0&id=22bffb75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VFlex,
  VLayout,
  VProgressLinear,
})
